import PropTypes from 'prop-types';
import ReactApexChart from 'react-apexcharts';
import ApexCharts from 'apexcharts'
// @mui
import { Box, Card, CardHeader } from '@mui/material';
// utils
import { useEffect } from 'react';
import { fNumber } from '../../../utils/formatNumber';
// components
import { useChart } from '../../../components/chart';

// ----------------------------------------------------------------------

AppTreemap.propTypes = {
  title: PropTypes.string,
  subheader: PropTypes.string,
  chartData: PropTypes.array.isRequired,
  showLabel: PropTypes.bool,
};



export default function AppTreemap({ chartname, title, subheader, chartData, showLabel, ...other }) {

  // console.log(chartData.map((i) => ({
  //   x: i.label,
  //   y: i.value
  // })));

  useEffect(() => {

    if (!chartData || !chartData.length) return
      
    const options = {
      series: [
      {
        data: chartData.map((i) => ({
          x: i.label,
          y: i.value
        }))
      }
    ],
      legend: {
      show: false
    },
    chart: {
      height: 320,
      type: 'treemap'
    },
    title: {
      text: title,
      style: {
        fontWeight:  'bold',
        color:  '#ffffff'
      },
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: '20px',
      },
      formatter(text, op) {
        return [text, op.value]
      },
      offsetY: -4
    },colors: [
      '#C0A974',
      '#475263',
      '#A07669',
      '#C4BDA4',
      '#A4A993',
      '#64777D',
      
      '#6EA89E',
      '#E6D7C1',
      '#F4C05B',
      '#B65F4D',
      '#553B23'
    ],
    plotOptions: {
      treemap: {
        distributed: true
      }
    }
    };

    const chart = new ApexCharts(document.querySelector(chartname? `#${chartname}` : "#chart"), options);
    chart.render();

  }, [chartData, chartname, title]);

  return (
    <Card {...other}>
      <div id={chartname ||  'chart'} />
    </Card>
  );
}
